import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {

}

@Component({
  selector: 'app-other-machines',
  templateUrl: './other-machines.component.html',
  styleUrls: ['./other-machines.component.scss']
})
export class OtherMachinesComponent  {

  // manufacturingTechnology: any;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: DialogData,
    // public dialogref: MatDialogRef<OtherMachinesComponent>
  ) { }

  // ngOnInit() {

  //   this.manufacturingTechnology = this.data["data"];
  //   console.log(this.manufacturingTechnology)
  // }

  // close() {
  //   this.dialogref.close();
  // }

}
